const setAreas = ({ commit }, payload) => {
  commit('ADD_AREAS', payload)
}

const setAreasLoading = ({ commit }, payload) => {
  commit('SET_AREAS_LOADING', payload)
}

const setMetrics = ({ commit }, payload) => {
  commit('SET_METRICS', payload)
}

export const removeMetric = ({ commit }, payload) => {
  commit('REMOVE_METRIC', payload)
}

const setMetricsLoading = ({ commit }, payload) => {
  commit('SET_METRICS_LOADING', payload)
}

const setCategories = ({ commit }, payload) => {
  commit('SET_CATEGORIES', payload)
}

const setCategoriesLoading = ({ commit }, payload) => {
  commit('SET_CATEGORIES_LOADING', payload)
}

const setRubrics = ({ commit }, payload) => {
  commit('SET_RUBRICS', payload)
}

const setRubricsLoading = ({ commit }, payload) => {
  commit('SET_RUBRICS_LOADING', payload)
}

const setMetricsPJ = ({ commit }, payload) => {
  commit('SET_METRICS_PJ', payload)
}

const setMetricsPJLoading = ({ commit }, payload) => {
  commit('SET_METRICS_PJ_LOADING', payload)
}

const setMetricsArea = ({ commit }, payload) => {
  commit('SET_METRICS_AREA', payload)
}

const setMetricsAreaLoading = ({ commit }, payload) => {
  commit('SET_METRICS_AREA_LOADING', payload)
}

export const setMetricsFilial = ({ commit }, payload) => {
  commit('SET_METRICS_FILIAL', payload)
}

export const setMetricsFilialLoading = ({ commit }, payload) => {
  commit('SET_METRICS_FILIAL_LOADING', payload)
}

const setDre = ({ commit }, payload) => {
  commit('SET_DRE', payload)
}

const setDreLoading = ({ commit }, payload) => {
  commit('SET_DRE_LOADING', payload)
}

export const setValuationOffice = ({ commit }, payload) => {
  commit('SET_VALUATION_OFFICE', payload)
}

export const setValuationOfficeLoading = ({ commit }, payload) => {
  commit('SET_VALUATION_OFFICE_LOADING', payload)
}

export const setValuationProfessional = ({ commit }, payload) => {
  commit('SET_VALUATION_PROFESSIONAL', payload)
}

export const setValuationProfessionalLoading = ({ commit }, payload) => {
  commit('SET_VALUATION_PROFESSIONAL_LOADING', payload)
}

export const setMargin = ({ commit }, payload) => {
  commit('SET_MARGIN', payload)
}

export const setMarginLoading = ({ commit }, payload) => {
  commit('SET_MARGIN_LOADING', payload)
}

export const setShowCategory = ({ commit }, payload) => {
  commit('SET_SHOW_CATEGORY', payload)
}

export const setQuantityCategory = ({ commit }, payload) => {
  commit('SET_QUANTITY_CATEGORY', payload)
}

export const setDataCategory = ({ commit }, payload) => {
  commit('SET_DATA_CATEGORY', payload)
}

export const setOptionsEditCategory = ({ commit }, payload) => {
  commit('SET_OPTIONS_EDIT_CATEGORY', payload)
}

export {
  setAreas,
  setAreasLoading,
  setMetrics,
  setMetricsLoading,
  setCategories,
  setCategoriesLoading,
  setRubrics,
  setRubricsLoading,
  setMetricsPJ,
  setMetricsPJLoading,
  setMetricsArea,
  setMetricsAreaLoading,
  setDre,
  setDreLoading,
}
